import './ImageUploader.scss'
import { useDropArea, useDrop } from 'react-use'
import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { LandscapeIcon, PortraitIcon } from './OrientationIcons'
import Slider from './Slider';
import { useStorage, useStorageDownloadURL } from 'reactfire'
import { ref } from 'firebase/storage'
import editIcon from '../../images/edit_icon_white.svg'
import trashIcon from '../../images/trashIcon.svg'
import confirm from '../Dialog'
const imageMimeTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
]

function constrain(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

const targetAspectRatio = 3 / 2
function FetchImage(props) {
  const { image } = props
  if (image.new) {
    return (
      <Image {...props} />
    )
  } else {
    return <StorageImage {...props} />
  }
}

function StorageImage(props) {
  const { image } = props
  let { name, path } = image
  const storage = useStorage()
  const imageRef = ref(storage, `grove-images/${name}`)
  const { data: imageURL } = useStorageDownloadURL(imageRef);
  if (!path && imageURL) {
    path = imageURL
  }
  const newImage = {...image, path}
  return (
    <Image {...props} image={newImage} />
  )
}
function Image(props) {
  const { image, editImage, removeImage } = props
  let { caption, path, editing, scale, translate, orientation, dimensions } = image
  const [tempCaption, setTempCaption] = useState(caption)
  const [tempScale, setTempScale] = useState(scale)
  const [tempTranslate, setTempTranslate] = useState(translate)
  const [tempOrientation, setTempOrientation] = useState(orientation)

  useEffect(() => {
    setTempCaption(caption)
  }, [caption])
  const updateCaption = e => {
    setTempCaption(e.target.value)
  }

  const save = () => {
    editImage({
      ...image,
      caption: tempCaption,
      scale: tempScale,
      translate: tempTranslate,
      orientation: tempOrientation,
      editing: false,
    })
  }
  const cancel = () => {
    if (image.new && !image.cancelWontDelete) {
      removeImage(image)
    } else {
      const newImage = {
        ...image,
        editing: false,
      }
      delete newImage.cancelWontDelete
      editImage(newImage)
    }
  }
  const edit = () => {
    editImage({
      ...image,
      editing: true,
      cancelWontDelete: true, // this is to prevent the image from being deleted when canceling
    })
  }
  const deleteHandler = async () => {

    if (await confirm({
      confirmation: <>Are you sure you want to delete this image?</>,
      actionText: 'Delete',
      actionColor: '#D34427',
    })) {
      removeImage(image)
    } else {
    }
  }
  const targetImageWidth = 200
  const targetImageHeight = targetImageWidth * targetAspectRatio

  const imageHeight = tempOrientation === 'portrait' ? targetImageHeight : targetImageWidth
  const imageWidth = tempOrientation === 'portrait' ? targetImageWidth : targetImageHeight
  const mouseDragInitialCoords = useRef({x: 0, y: 0})
  const mouseDown = (e) => {
    if (!editing) {
      return
    }
    mouseDragInitialCoords.current = {
      x: e.clientX,
      y: e.clientY,
    }

    const mouseMove = (e) => {
      const currentCords = {
        x: e.clientX,
        y: e.clientY,
      }
      const deltaCoords = {
        x: currentCords.x - mouseDragInitialCoords.current.x,
        y: currentCords.y - mouseDragInitialCoords.current.y,
      }
      mouseDragInitialCoords.current.x = currentCords.x
      mouseDragInitialCoords.current.y = currentCords.y

      const maxTranslate = 50
      setTempTranslate(t =>
        [
          constrain(t[0] + deltaCoords.x / tempScale, -maxTranslate, maxTranslate),
          constrain(t[1] + deltaCoords.y / tempScale, -maxTranslate, maxTranslate)
        ])
    }
    const mouseUp = (e) => {
      document.removeEventListener('mousemove', mouseMove)
      document.removeEventListener('mouseup', mouseUp)
      document.body.classList.remove('dragging')
    }

    document.addEventListener('mousemove', mouseMove)
    document.addEventListener('mouseup', mouseUp)
    document.body.classList.add('dragging')
  }
  // const initialScaleFactor = Math.min(dimensions.width / imageWidth, dimensions.height / imageHeight)
  const initialScaleFactor = Math.max(imageWidth / dimensions.width, imageHeight / dimensions.height) * 100
  // const initialScaleFactor = Math.max(dimensions.width / imageWidth, dimensions.height / imageHeight)
  // const initialScaleFactor = Math.max(imageWidth / dimensions.width, imageHeight / dimensions.height)
  return (
    <div className='Image'>
      <div style={{
        width: imageWidth,
        height: imageHeight,
        backgroundImage: `url("${path}")`,
        // backgroundSize: `${dimensions.width / imageWidth * 50 * tempScale}% ${dimensions.height / imageHeight * 50* tempScale}%`,
        backgroundSize: `${(dimensions.width / imageWidth ) * tempScale * initialScaleFactor}% ${( dimensions.height / imageHeight) * tempScale * initialScaleFactor}%`,
        backgroundPosition: `${50 - tempTranslate[0]}% ${50 - tempTranslate[1]}%`,

        cursor: editing ? 'move' : 'default',
      }}
      className='image'
      onMouseDown={mouseDown}
      >
        {editing ? null :

          <div className='imageButtons'>
            <img alt='edit' src={editIcon} onClick={edit} />
            <img alt='delete' src={trashIcon} onClick={deleteHandler} />
          </div>
        }
        </div>

      {editing ?
        <div className='editImageControls'>
          <div className='buttons'>
            <div className='orientationButtons'>
              <LandscapeIcon selected={tempOrientation === 'landscape'} onClick={e => setTempOrientation('landscape')} />
              <PortraitIcon selected={tempOrientation === 'portrait'} onClick={e => setTempOrientation('portrait')} />
            </div>
            <Slider
              style={{ width: '190px' }}
              step={0.01}
              min={0.9}
              max={3}
              value={tempScale}
              onChange={(e) => {
                setTempScale(e.target.value)
              }}
            />
          </div>
          <input className='caption' type="text" value={tempCaption} placeholder='image caption' onChange={updateCaption} />
          <div>
            <label>
              <button onClick={cancel}>Cancel</button>
              <button onClick={save} className='save'>Save</button>
            </label>
          </div>
        </div> : null
      }
    </div>
  )
}

function NewImage(props) {
  const { addImage } = props
  const createFile = (file) => {
    if (!imageMimeTypes.includes(file.type)) {
      return
    }
    const reader = new FileReader()
    const image = new window.Image()
    image.onload = () => {
      const dimensions = { width: image.width, height: image.height }
      const aspectRatio = dimensions.width / dimensions.height
      const orientation = aspectRatio > targetAspectRatio ? 'landscape' : 'portrait'
      const filename = file.name
      const extension = filename.split('.').pop()
      const name = filename.split('.').slice(0, -1).join('.')
      const randomHash = Math.random().toString(36).substring(2, 8)
      const newName = `${name}_${Date.now()}_${randomHash}.${extension}`
      addImage({
        caption: '',
        path: reader.result,
        editing: true,
        scale: 1,
        translate: [0, 0],
        dimensions,
        orientation,
        new: true,
        name: newName,
        mimeType: file.type,
      })

    }
    reader.onload = () => {
      image.src = reader.result
    }
    reader.readAsDataURL(file)

  }
  const openFileDialog = (e) => {
    e.preventDefault()
    createFile(e.target.files[0])
  }
  const [bond, state] = useDropArea({
    onFiles: files => {
      createFile(files[0])
    }
  });
  const clickUploadButton = (e) => {
    e.preventDefault()
    fileUploadRef.current.click()
  }
  useDrop({
    onFiles: files => {
      createFile(files[0])
    }
  })
  const fileUploadRef = useRef()
  return (
    <div className='NewImage Image'>
      <label>
        <div className={ classNames('dropArea', state)} {...bond}>
          <div className='dropAreaText'>
            Drag the image here or <br />
            click the upload button
          </div>
        </div>
        <button onClick={clickUploadButton}>Upload</button>
        <input className='hidden' type='file' onChange={openFileDialog} ref={fileUploadRef} />
      </label>
    </div>

  )
}
export default function ImageUploader(props) {
  const { images, setImages } = props

  const editImage = (index) => (image) => {
    const newImages = [...images]
    newImages[index] = image
    setImages(newImages)
  }
  const addImage = (image) => {
    const newImages = [...images, image]
    setImages(newImages)
  }
  const removeImage = (image) => {
    const newImages = images.filter(i => i.name !== image.name)
    setImages(newImages)
  }
  return (
    <>
      <label style={{ marginLeft: '1em', marginBottom: 0}}><span>Add Images (up to 5)</span></label>
      <div className='ImageUploader'>
        {images.map((image, index) => {
          return (
            <FetchImage key={index} image={image} editImage={editImage(index)} removeImage={removeImage} />
          )
        })}
        {images.length < 5 ? <NewImage addImage={addImage} /> : null}
      </div>
    </>
  )
}
